import { useNavigate } from 'react-router-dom'
import { DeadlinesCard } from '@/app/dashboard/widgets'
import { useUpcomingDeadlines } from '../hooks'

/**
 * Widget pulpitu „Najbliższe terminy" (prawa kolumna, `design-main.png`).
 *
 * Rdzeń renderuje pustą kartę tylko wtedy, gdy żaden moduł nie dostarczy widgetu
 * o identyfikatorze `deadlines.*` — dlatego id musi zostać `deadlines.upcoming`.
 * Dane: `GET /api/deadlines/upcoming` bez parametrów (terminy użytkownika + pozycje
 * bez przypisania, ZALEGŁE NA GÓRZE); chip „za N dni" / „N dni temu" koloruje
 * `dueVariant` z rdzenia — ta sama lista, którą zlicza kafel KPI `/deadlines/stats`.
 */
export function UpcomingDeadlinesWidget() {
  const navigate = useNavigate()
  const { data, isPending } = useUpcomingDeadlines(5)

  return (
    <DeadlinesCard
      loading={isPending}
      moreHref="/terminy"
      items={(data?.items ?? []).map((deadline) => ({
        id: deadline.id,
        date: deadline.due_date,
        title: deadline.title,
        meta: deadline.case
          ? `${deadline.case.signature} · ${deadline.case.client_name}`
          : 'brak przypisania',
        // Deep link otwiera ten konkretny termin na ekranie „Terminy procesowe".
        onClick: () => navigate(`/terminy?termin=${deadline.id}`),
      }))}
    />
  )
}
